import React, { useEffect } from 'react';
import { useDashboard } from '../../context/DashboardContext';
import { useChat } from '../../context/ChatContext';
import ChatSidebar from './ChatSidebar';
import ChatWindow from './ChatWindow';
import BackButton from '../Common/BackButton';
import './TalkSection.css';

/**
 * TalkSection - Root component for the Talk feature
 * Provides the main layout container for sidebar and chat window
 */
const TalkSection = () => {
    const { fetchConversations, hideSidebar, setActiveConversationId } = useChat();
    const { setActiveView, returnView, deepLink, setDeepLink } = useDashboard();

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchConversations(1);
        }, 100);
        return () => clearTimeout(timer);
    }, [fetchConversations]);

    // Handle deep-link navigation from notifications
    useEffect(() => {
        if (!deepLink || deepLink.target_type !== 'conversation') return;
        setActiveConversationId(deepLink.target_id);
        setDeepLink(null);
    }, [deepLink, setActiveConversationId, setDeepLink]);

    // Request notification permission on mount
    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    console.log('Notification permission granted');
                }
            });
        }
    }, []);

    return (
        <div className="talk-section-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="dashboard-section-header">
                <h1 className="dashboard-section-title">
                    <BackButton
                        onClick={() => setActiveView(returnView)}
                        ariaLabel="Back to Dashboard"
                    />
                    Talk
                </h1>
            </div>
            <div className="talk-container talk-layout" style={{ flexGrow: 1, height: '0', minHeight: '0' }}>
                {!hideSidebar && <ChatSidebar />}
                <ChatWindow />
            </div>
        </div>
    );
};

export default TalkSection;
